import {createFileRoute} from '@tanstack/react-router';
import {PaymentCallbackCancelPage} from 'features/shared/payment/pages/PaymentCallbackCancelPage';

export const Route = createFileRoute(
  '/_protected/statement-payment/$statementId/callback/_statuses/cancel',
)({
  component: () => (
    <PaymentCallbackCancelPage
      pageId="statement_payment_cancel"
      navigateTo="/home/statements"
    />
  ),
});
